var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Users / User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 12.0834C17.1694 12.0834 19.3334 9.9194 19.3334 7.25002C19.3334 4.58064 17.1694 2.41669 14.5 2.41669C11.8306 2.41669 9.66669 4.58064 9.66669 7.25002C9.66669 9.9194 11.8306 12.0834 14.5 12.0834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.1666 21.1458C24.1666 24.1489 24.1666 26.5833 14.5 26.5833C4.83331 26.5833 4.83331 24.1489 4.83331 21.1458C4.83331 18.1427 9.16122 15.7083 14.5 15.7083C19.8388 15.7083 24.1666 18.1427 24.1666 21.1458Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user_white.43e935af989c353ebdc5868b45e20d45.svg";
export { ForwardRef as ReactComponent };